import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EconomyActivitiesTables = _resolveComponent("EconomyActivitiesTables")!
  const _component_DashboardContentLayout = _resolveComponent("DashboardContentLayout")!

  return (_openBlock(), _createBlock(_component_DashboardContentLayout, {
    class: "space-y-4",
    heading: _ctx.$t('views.economy.status.header.heading'),
    "has-period-picker": true,
    "has-pig-type-picker": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_EconomyActivitiesTables)
    ]),
    _: 1
  }, 8, ["heading"]))
}